module.exports = __webpack_public_path__ + "img/vertical_7_2_6005.d004b743.png";